export function getAppUrl () {
  const { protocol, hostname } = window.location

  // Electron production builds load the renderer from file://, so window.location
  // is unusable as an origin. Fall back to the build-time API_URL.
  if (protocol === 'file:') {
    return process.env.API_URL
  }

  if (hostname.startsWith('talk.')) {
    return `${protocol}//` + hostname.replace(/^talk\./, 'app.')
  }

  return `${protocol}//${hostname}`
}

/**
 * A route guard that opens an admin app page. From inside talk2 it opens a new tab, as the app's other "open in admin"
 * links do, and keeps talk2 where it was. As the first page loaded (a pasted link) there is no click to allow a
 * popup, so this tab goes to the admin page instead.
 */
export function openInAdminApp (pathOf) {
  return (to, from, next) => {
    const url = getAppUrl() + pathOf(to.params)

    if (from.matched.length === 0) {
      window.location.replace(url)
    } else {
      window.open(url, '_blank')
    }

    next(false)
  }
}

export default {
  methods: {
    getCampaignURL (campaignId) {
      return getAppUrl() + `/lines/${campaignId}/settings`
    },

    getCampaignActivityURL (campaignId) {
      return getAppUrl() + `/lines/${campaignId}/activity`
    },

    getRingGroupURL (ringGroupId) {
      return getAppUrl() + `/ring-groups/dialog/${ringGroupId}`
    },

    getUserURL (userId) {
      return getAppUrl() + `/users/dialog/${userId}`
    },

    getUserActivityURL (userId) {
      return getAppUrl() + `/users/${userId}/activity`
    },

    getWorkflowURL (workflowId) {
      return getAppUrl() + `/sequences2/manager/${workflowId}`
    },

    getFlowURL (flowId) {
      return getAppUrl() + `/flows/${flowId}`
    },

    getBroadcastSettingURL () {
      return getAppUrl() + '/account?tab=settings#broadcasts_business_hours'
    },

    getComplianceURL () {
      return getAppUrl() + '/account?tab=compliance'
    },

    getInternationalPricingURL () {
      return getAppUrl() + '/account?tab=international_pricing'
    },

    getClassicURL () {
      return getAppUrl()
    }
  }
}
